/* eslint-disable no-unused-expressions */
// @flow
/* eslint-disable quote-props */
// TODO Fix lint/flow config.
// Flow does not accept non string literal props but prettier-lint removes the quotes

import React, { useEffect } from 'react';
import compose from 'lodash/fp/compose';

import LazyLoad from 'react-lazyload';
import GridCarousel from '@components/GridCarousel/index';

import { withTranslation, Link } from '@i18n';
import PartnerHospital from '@screens/Home/components/PartnerHospital/index';
import PatientTestimonial from '@components/PatientTestimonial/index';
import HomeBannerBottom from '@components/HomeBannerBottom/index';
import { connect } from 'react-redux';
import ItemsCarousel from 'react-items-carousel';
import SearchResultListItem from '@screens/Finder/Doctor/SearchResultList/SearchResultListItem/index';
import ProgressBar from '@components/ContributionCard/ProgressBar';
import { calculateGridUnitSize } from '@lib/helpers';

import { requestDoctorList } from '@screens/Finder/Doctor/redux/actions';
import type { Props } from './types';

import {
  StyledCover,
  StyledCoverBlock,
  StyledContent,
  StyledContentCover,
  StyledHeader,
  StyledHeadlineText,
  StyledAllButton,
  StyledBannerSeperatorBlock,
} from './styles';

const BannerRight = ({
  t, Mobile, Tablet, OpenandPlay, setVideoUrl, requestDoctorList, doctorFinder
}: Props) => {
  const itemsPerPage = Mobile ? 4 : 8;
  useEffect(() => {
    requestDoctorList({ custom_per_page: itemsPerPage });
  }, []);
  const [doctorsSlide, setDoctorsSlide] = React.useState(0);
  const [intervalDoctorId, setDoctorIntervalId] = React.useState(null);
  const doctorList = doctorFinder.data || [];
  const color = '#5FA6BF';
  const handleDoctorTimeInterval = () => {
    clearInterval(intervalDoctorId);
    const newId = setInterval(() => {
      setDoctorsSlide((x) => {
        if (x > (doctorList || []).length - 1) {
          return 0;
        }
        return x + 1;
      });
    }, 4000);

    setDoctorIntervalId(newId);
  };

  return (
    <LazyLoad height="100%" offset={800} once>
      <StyledCover>
        <StyledCoverBlock>
          <StyledContentCover>
            <StyledContent>
              <StyledHeader>
                <StyledHeadlineText animate>{t('hero.RightTitle')}</StyledHeadlineText>
              </StyledHeader>
            </StyledContent>
          </StyledContentCover>
        </StyledCoverBlock>

        {Mobile
          ? (
            <>
              <ItemsCarousel
                requestToChangeActive={setDoctorsSlide}
                activeItemIndex={doctorsSlide}
                numberOfCards={1}
                gutter={20}
                alwaysShowChevrons
                showIndicators
              >
                {(doctorList || []).slice(0, 8).map(doctor => (
                  <SearchResultListItem
                    key={`result-list-item-${doctor.id}`}
                    result={doctor}
                    bookConsultation="hide"
                    size={{
                      mobile:
                            1
                    }}
                  />
                ))}
              </ItemsCarousel>
              {doctorList.length > 1 && (
              <ProgressBar
                slide={doctorsSlide}
                handleTimeInterval={handleDoctorTimeInterval}
                setSlide={setDoctorsSlide}
                intervalId={intervalDoctorId}
                clickable
                color={color}
                homePage
                length={(doctorList || []).slice(0, 8).length}
                contributionCard
              />
              )}
            </>
          )
          : (
            <GridCarousel
              length={(doctorList || []).slice(0, 8).length}
              onScreenCount={4}
              pagination
              homePage
              contributionCard
            >
              <>
                {(doctorList || []).slice(0, 8).map(doctor => (
                  <SearchResultListItem
                    key={`result-list-item-${doctor.id}`}
                    result={doctor}
                    bookConsultation="hide"
                    size={{
                      mobile:
                          1
                          / calculateGridUnitSize((doctorList || []).slice(0, 8).length, 4)
                    }}
                  />
                ))}
              </>
            </GridCarousel>
          )}

        <Link passHref href="/doctors">
          <StyledAllButton>{t('hero.ViewDoctors')}</StyledAllButton>
        </Link>
      </StyledCover>


      <PartnerHospital />

      <PatientTestimonial
        isMobile={Mobile}
        isTablet={Tablet}
        onOpenModal={OpenandPlay}
        setVideoUrl={setVideoUrl}
      />

      <StyledBannerSeperatorBlock>
        <HomeBannerBottom />
      </StyledBannerSeperatorBlock>
    </LazyLoad>
  );
};

const mapStateToProps = ({ doctorFinder }: GlobalState): {} => ({
  doctorFinder
});

export default compose(
  withTranslation('Home'),
  connect(
    mapStateToProps,
    {
      requestDoctorList
    },
  ),
)(BannerRight);
